import React from 'react'
import { Box, DataListItem } from '@node-space/ui-components'

interface SummaryDetailsListProps {
  details: Record<string, string>
}

export const SummaryDetailsList = ({ details }: SummaryDetailsListProps) => {
  return (
    <Box test-id="beneficiaryDepositDetails">
      {Object.keys(details || {}).map(label => {
        return (
          <DataListItem
            key={label}
            id={label}
            title={label}
            body={details?.[label]}
            layout={'horizontal'}
          />
        )
      })}
    </Box>
  )
}
